import Image from 'next/image';

interface IconButtonProps {
  url: string;
  className?: string;
  onClick: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const IconButton = ({ url, className, onClick, disabled, style }: IconButtonProps) => {
  return (
    <button className={`relative ${className}`} onClick={onClick} disabled={disabled} style={style}>
      <Image src={url} alt="icon" fill sizes="100%" objectFit="contain" />
    </button>
  );
};

export default IconButton;
